export default function () {
  return {
    title: [String, Number],
    value: [String, Number, Array],
    placeholder: [String, Number],
    required: Boolean,
    valueAlign: String,
    valueColor: String,
    isTopTitle: Boolean,
    isLink: Boolean,
    isLoading: Boolean,
    inlineDesc: [String, Number],
    primary: {
      type: String,
      default: 'title'
    },
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    arrowDirection: String, // down or up
    alignItems: String
  }
}



// WEBPACK FOOTER //
// ./src/components/common/cell-placeholder/props.js